module.exports = __webpack_public_path__ + "public/img/icon_sheji.e432e91d.png";